import { render, staticRenderFns } from "./rightSidebarSectionProcess.vue?vue&type=template&id=4a8539ac"
import script from "./rightSidebarSectionProcess.vue?vue&type=script&lang=js"
export * from "./rightSidebarSectionProcess.vue?vue&type=script&lang=js"
import style0 from "./rightSidebarSectionProcess.vue?vue&type=style&index=0&id=4a8539ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports